import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  root: {
    borderRadius: 20,
  },
  date: {
    height: 20,
    width: 100,
    margin: "8px 0",
  },
  activityItem: {
    boxShadow: "none",
    height: 65,
    marginBottom: 10,
    borderRadius: 20,
  },
});
